export default {
  namespaced: true,

  state: {
    fontSelectorLoading: false
  },
  getters: {
  },
  mutations: {
    updateFontSelectorLoading(state, val) {
      state.fontSelectorLoading = val
    }
  },

  actions: {
  }
}
